module.exports = "/images/noFoundOne.svg";